import type { FxConversionMetadata, FxRateSnapshotRef } from '../types/fx'

type BuildUnavailableFxConversionMetadataArgs = {
  sourceAmountCents: number
  sourceCurrency: string
  targetCurrency: string
  asOf: string
  roundingPolicyVersion: string
  detail?: string
}

type BuildConvertedFxConversionMetadataArgs = {
  sourceAmountCents: number
  sourceCurrency: string
  targetCurrency: string
  convertedAmountCents: number
  asOf: string
  roundingPolicyVersion: string
  rate: FxRateSnapshotRef
}

export const buildUnavailableFxConversionMetadata = (
  args: BuildUnavailableFxConversionMetadataArgs
): FxConversionMetadata => ({
  status: 'unavailable',
  sourceAmountCents: args.sourceAmountCents,
  sourceCurrency: args.sourceCurrency,
  targetCurrency: args.targetCurrency,
  asOf: args.asOf,
  roundingPolicyVersion: args.roundingPolicyVersion,
  reason: 'missing-rate',
  detail: args.detail
})

export const buildConvertedFxConversionMetadata = (
  args: BuildConvertedFxConversionMetadataArgs
): FxConversionMetadata => ({
  status: 'converted',
  sourceAmountCents: args.sourceAmountCents,
  sourceCurrency: args.sourceCurrency,
  targetCurrency: args.targetCurrency,
  convertedAmountCents: args.convertedAmountCents,
  asOf: args.asOf,
  roundingPolicyVersion: args.roundingPolicyVersion,
  rate: args.rate
})
